import { wrapCall, callGet, callPost, callPut, callDelete } from './helpers'

//* ~~~~~~ ROLES ROUTES ~~~~~~

// Sends GET request to API to get roles in the systme
export const getRoles = async () => {
  return await wrapCall({
    method: callGet,
    uri: '/roles'
  })
}

// Creates a new role in system
export const createRole = async data => {
  return await wrapCall({ method: callPost, uri: '/roles', data })
}

// Edits a role
export const editRole = async (id, data) => {
  return await wrapCall({
    method: callPut,
    uri: `/roles/${id}`,
    data
  })
}

// Deletes a role
export const deleteRole = async id => {
  return await wrapCall({
    method: callDelete,
    uri: `/roles/${id}`
  })
}

//* ~~~~~~ PERMISSIONS ~~~~~~

// getting all permissions from system
export const getPermissions = async () => {
  return await wrapCall({
    method: callGet,
    uri: `/roles/permissions`
  })
}
